module.exports = window["Bernie_l10nBundle_et_EE"];